module.exports = "/_next/static/images/1bc8fa60e6c4c536387fa06c5cdf3cc4-hero-desktop-10.jpg.webp";